module.exports = __webpack_public_path__ + "static/cosycolour5-2c3f46eba2ec7f090c5e0bb29eeca5a3.png";